import styled from "styled-components";

export const SimpletaxLogo = styled.img`
  width: ${(props) => props.width || "150px"};
  @media only screen and (max-width: 767px) {
    width: 200px;
  }
`;
